import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza.tsx';
import { CreateInviteUserForm } from './create-invite-user-form.tsx';

export const CreateInviteUserDialog = ({
  isDialogOpen,
  setIsDialogOpen,
  children,
}: {
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
  children: ReactNode;
}) => {
  const { t } = useTranslation();

  return (
    <Credenza open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <CredenzaTrigger asChild>{children}</CredenzaTrigger>
      <CredenzaContent className="max-w-2xl gap-1">
        <CredenzaHeader className="pb-0">
          <CredenzaTitle>{t('users.invite.dialog.title')}</CredenzaTitle>
          <CredenzaDescription>{t('users.invite.dialog.description')}</CredenzaDescription>
        </CredenzaHeader>

        <CredenzaBody className="max-w-2xl gap-1">
          <CreateInviteUserForm onClose={() => setIsDialogOpen(false)} />
        </CredenzaBody>
        <CredenzaFooter className="pb-0">
          <div></div>
        </CredenzaFooter>
      </CredenzaContent>
    </Credenza>
  );
};
